module.exports = __webpack_public_path__ + "img/integer.519587a1.svg";